import { is, kTrue } from './utils';
export var array = function array(patterns) {
  return function (input) {
    return patterns.some(function (p) {
      return matcher(p)(input);
    });
  };
};
export var predicate = function predicate(_predicate) {
  return function (input) {
    return _predicate(input);
  };
};
export var string = function string(pattern) {
  return function (input) {
    return input.type === String(pattern);
  };
};
export var symbol = function symbol(pattern) {
  return function (input) {
    return input.type === pattern;
  };
};
export var wildcard = function wildcard() {
  return kTrue;
};
export default function matcher(pattern) {
  // prettier-ignore
  var matcherCreator = pattern === '*' ? wildcard : is.string(pattern) ? string : is.array(pattern) ? array : is.stringableFunc(pattern) ? string : is.func(pattern) ? predicate : is.symbol(pattern) ? symbol : null;

  if (matcherCreator === null) {
    throw new Error("invalid pattern: " + pattern);
  }

  return matcherCreator(pattern);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-saga/es/internal/matcher.js
// module id = 400
// module chunks = 58